export class OverlayMetadata{
  overlayType?: string;
  ctaType?: string;
  destinationUrl?: string;
  actionType?: string;
  targetOverlayId?: string;

  constructor(dataset: any = {}){
    this.overlayType = dataset.overlayType;
    this.ctaType = dataset.ctaType;
    this.destinationUrl = dataset.destinationUrl;
    this.actionType = dataset.actionType;
    this.targetOverlayId = dataset.contentFetch;
  }
}